"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GambleAssetConfig = exports.GambleAsset = void 0;
class GambleAsset {
    /**
     * @constructs
     * @param name
     * @param height
     * @param width
     * @param url
     */
    constructor(name, height, width, url) {
        this.name = name;
        this.url = url ? url : GambleAssetConfig.makeAssetPath(name);
        this.height = height;
        this.width = width;
    }
}
exports.GambleAsset = GambleAsset;
class GambleAssetConfig {
    static set useDefaultAssets(value) {
        this._useDefaultAssets = value;
    }
    static getDefaultResourcePath() {
        return "/node_modules/@nolimitcity/slot-gamble/";
    }
    static getGameResourcePath() {
        return "/nolimit/slot-gamble/";
    }
    static getResourcePath() {
        const pathSuffix = "resources/default/";
        if (GambleAssetConfig._useDefaultAssets) {
            return GambleAssetConfig.getDefaultResourcePath() + pathSuffix;
        }
        else {
            return GambleAssetConfig.getGameResourcePath() + pathSuffix;
        }
    }
    static makeAssetPath(asset) {
        return this.getResourcePath() + asset;
    }
    static getImgConfigs() {
        return [
            new GambleAsset(GambleAssetConfig.BG),
            new GambleAsset(GambleAssetConfig.BLACK_BUTTON),
            new GambleAsset(GambleAssetConfig.BLACK_BUTTON_TOGGLE),
            new GambleAsset(GambleAssetConfig.RED_BUTTON),
            new GambleAsset(GambleAssetConfig.RED_BUTTON_TOGGLE),
            new GambleAsset(GambleAssetConfig.GAMBLE_BUTTON),
            new GambleAsset(GambleAssetConfig.GAMBLE_BUTTON_TOGGLE),
            new GambleAsset(GambleAssetConfig.COLLECT_BUTTON),
            new GambleAsset(GambleAssetConfig.COLLECT_BUTTON_TOGGLE),
            new GambleAsset(GambleAssetConfig.SPIN_WHEEL_RED_BUTTON),
            new GambleAsset(GambleAssetConfig.SPIN_WHEEL_WHITE_BUTTON),
            new GambleAsset(GambleAssetConfig.GAMBLE_TEXT),
            new GambleAsset(GambleAssetConfig.FIFTY_FIFTY_TEXT),
            new GambleAsset(GambleAssetConfig.WHEEL_OF_BONUS_TEXT),
            new GambleAsset(GambleAssetConfig.SPIN_TEXT),
            new GambleAsset(GambleAssetConfig.CLICK_ANIMATION_0),
            new GambleAsset(GambleAssetConfig.CLICK_ANIMATION_1),
            new GambleAsset(GambleAssetConfig.CLICK_ANIMATION_2),
            new GambleAsset(GambleAssetConfig.CLICK_ANIMATION_3),
            new GambleAsset(GambleAssetConfig.CLICK_ANIMATION_4),
            new GambleAsset(GambleAssetConfig.CLICK_ANIMATION_5),
            new GambleAsset(GambleAssetConfig.CLICK_ANIMATION_6),
            new GambleAsset(GambleAssetConfig.CLICK_ANIMATION_7),
            new GambleAsset(GambleAssetConfig.CLICK_ANIMATION_8),
            new GambleAsset(GambleAssetConfig.CARDS_BG),
            new GambleAsset(GambleAssetConfig.CARDS_COMMON_ANIM),
            new GambleAsset(GambleAssetConfig.BLACK_SPADE_0),
            new GambleAsset(GambleAssetConfig.BLACK_SPADE_1),
            new GambleAsset(GambleAssetConfig.BLACK_SPADE_2),
            new GambleAsset(GambleAssetConfig.BLACK_SPADE_3),
            new GambleAsset(GambleAssetConfig.RED_HEART_0),
            new GambleAsset(GambleAssetConfig.RED_HEART_1),
            new GambleAsset(GambleAssetConfig.RED_HEART_2),
            new GambleAsset(GambleAssetConfig.RED_HEART_3),
            new GambleAsset(GambleAssetConfig.CARD_GLOW),
            new GambleAsset(GambleAssetConfig.RED_HEART_HISTORY),
            new GambleAsset(GambleAssetConfig.BLACK_SPADE_HISTORY),
            new GambleAsset(GambleAssetConfig.FIFTY_FIFTY_CHOICE),
            new GambleAsset(GambleAssetConfig.FIFTY_FIFTY_CHOICE_TOGGLE),
            new GambleAsset(GambleAssetConfig.WHEEL_CHOICE),
            new GambleAsset(GambleAssetConfig.WHEEL_CHOICE_TOGGLE),
            new GambleAsset(GambleAssetConfig.POINTER_0),
            new GambleAsset(GambleAssetConfig.POINTER_1),
            new GambleAsset(GambleAssetConfig.POINTER_2),
            new GambleAsset(GambleAssetConfig.POINTER_3),
            new GambleAsset(GambleAssetConfig.POINTER_4),
            new GambleAsset(GambleAssetConfig.POINTER_5),
            new GambleAsset(GambleAssetConfig.POINTER_6),
            new GambleAsset(GambleAssetConfig.POINTER_7),
            new GambleAsset(GambleAssetConfig.POINTER_8),
            new GambleAsset(GambleAssetConfig.POINTER_9),
            new GambleAsset(GambleAssetConfig.POINTER_10),
            new GambleAsset(GambleAssetConfig.POINTER_11),
            new GambleAsset(GambleAssetConfig.POINTER_12),
            new GambleAsset(GambleAssetConfig.POINTER_13),
            new GambleAsset(GambleAssetConfig.POINTER_14),
            new GambleAsset(GambleAssetConfig.POINTER_15),
            new GambleAsset(GambleAssetConfig.POINTER_16),
            new GambleAsset(GambleAssetConfig.POINTER_17),
            new GambleAsset(GambleAssetConfig.FEATURE_IMAGE),
            new GambleAsset(GambleAssetConfig.OUTER_RING),
            new GambleAsset(GambleAssetConfig.OUTER_RING_GLOW),
            new GambleAsset(GambleAssetConfig.WHEEL),
            new GambleAsset(GambleAssetConfig.WHEEL_GLOW),
            new GambleAsset(GambleAssetConfig.WIN_WHEEL_GLOW_0),
            new GambleAsset(GambleAssetConfig.WIN_WHEEL_GLOW_1),
            new GambleAsset(GambleAssetConfig.WIN_WHEEL_GLOW_2),
            new GambleAsset(GambleAssetConfig.WIN_WHEEL_GLOW_3),
            new GambleAsset(GambleAssetConfig.WIN_WHEEL_GLOW_4),
            new GambleAsset(GambleAssetConfig.WIN_WHEEL_GLOW_5),
            new GambleAsset(GambleAssetConfig.WIN_WHEEL_GLOW_6),
            new GambleAsset(GambleAssetConfig.WIN_OUTER_RING_GLOW_0),
            new GambleAsset(GambleAssetConfig.WIN_OUTER_RING_GLOW_1),
            new GambleAsset(GambleAssetConfig.WIN_OUTER_RING_GLOW_2),
            new GambleAsset(GambleAssetConfig.WIN_OUTER_RING_GLOW_3),
            new GambleAsset(GambleAssetConfig.WIN_OUTER_RING_GLOW_4),
            new GambleAsset(GambleAssetConfig.WIN_OUTER_RING_GLOW_5),
            new GambleAsset(GambleAssetConfig.WIN_OUTER_RING_GLOW_6),
            new GambleAsset(GambleAssetConfig.WIN_OUTER_RING_GLOW_7)
        ];
    }
}
exports.GambleAssetConfig = GambleAssetConfig;
// --------- IMG
GambleAssetConfig.BG = "bg/GambleBG.png";
GambleAssetConfig.BLACK_BUTTON = "buttons/BlackButton.png";
GambleAssetConfig.BLACK_BUTTON_TOGGLE = "buttons/BlackButtonToggle.png";
GambleAssetConfig.RED_BUTTON = "buttons/RedButton.png";
GambleAssetConfig.RED_BUTTON_TOGGLE = "buttons/RedButtonToggle.png";
GambleAssetConfig.GAMBLE_BUTTON = "buttons/GambleButton.png";
GambleAssetConfig.GAMBLE_BUTTON_TOGGLE = "buttons/GambleButtonToggle.png";
GambleAssetConfig.COLLECT_BUTTON = "buttons/CollectButton.png";
GambleAssetConfig.COLLECT_BUTTON_TOGGLE = "buttons/CollectButtonToggle.png";
GambleAssetConfig.SPIN_WHEEL_RED_BUTTON = "buttons/SpinWheelButtonRed.png";
GambleAssetConfig.SPIN_WHEEL_WHITE_BUTTON = "buttons/SpinWheelButtonWhite.png";
GambleAssetConfig.GAMBLE_TEXT = "text/GambleText.png";
GambleAssetConfig.FIFTY_FIFTY_TEXT = "text/5050.png";
GambleAssetConfig.WHEEL_OF_BONUS_TEXT = "text/WheelOfBonusHeader.png";
GambleAssetConfig.SPIN_TEXT = "text/SpinText.jpg";
GambleAssetConfig.CLICK_ANIMATION_0 = "clickAnimation/ClickFX/ClickFX_0.jpg";
GambleAssetConfig.CLICK_ANIMATION_1 = "clickAnimation/ClickFX/ClickFX_1.jpg";
GambleAssetConfig.CLICK_ANIMATION_2 = "clickAnimation/ClickFX/ClickFX_2.jpg";
GambleAssetConfig.CLICK_ANIMATION_3 = "clickAnimation/ClickFX/ClickFX_3.jpg";
GambleAssetConfig.CLICK_ANIMATION_4 = "clickAnimation/ClickFX/ClickFX_4.jpg";
GambleAssetConfig.CLICK_ANIMATION_5 = "clickAnimation/ClickFX/ClickFX_5.jpg";
GambleAssetConfig.CLICK_ANIMATION_6 = "clickAnimation/ClickFX/ClickFX_6.jpg";
GambleAssetConfig.CLICK_ANIMATION_7 = "clickAnimation/ClickFX/ClickFX_7.jpg";
GambleAssetConfig.CLICK_ANIMATION_8 = "clickAnimation/ClickFX/ClickFX_8.jpg";
GambleAssetConfig.CARDS_BG = "cards/CardFlip/CardFlip_CommonBeginning/CardFlip_CommonBeginning_0.png";
GambleAssetConfig.CARDS_COMMON_ANIM = "cards/CardFlip/CardFlip_CommonBeginning/CardFlip_CommonBeginning_1.png";
GambleAssetConfig.BLACK_SPADE_0 = "cards/CardFlip/CardFlip_BlackSpades/CardFlip_BlackSpades_0.png";
GambleAssetConfig.BLACK_SPADE_1 = "cards/CardFlip/CardFlip_BlackSpades/CardFlip_BlackSpades_1.png";
GambleAssetConfig.BLACK_SPADE_2 = "cards/CardFlip/CardFlip_BlackSpades/CardFlip_BlackSpades_2.png";
GambleAssetConfig.BLACK_SPADE_3 = "cards/CardFlip/CardFlip_BlackSpades/CardFlip_BlackSpades_3.png";
GambleAssetConfig.RED_HEART_0 = "cards/CardFlip/CardFlip_RedHeart/CardFlip_RedHeart_0.png";
GambleAssetConfig.RED_HEART_1 = "cards/CardFlip/CardFlip_RedHeart/CardFlip_RedHeart_1.png";
GambleAssetConfig.RED_HEART_2 = "cards/CardFlip/CardFlip_RedHeart/CardFlip_RedHeart_2.png";
GambleAssetConfig.RED_HEART_3 = "cards/CardFlip/CardFlip_RedHeart/CardFlip_RedHeart_3.png";
GambleAssetConfig.CARD_GLOW = "cards/CardGlow.jpg";
GambleAssetConfig.RED_HEART_HISTORY = "cards/CardHistory/CardHistoryRedHearts.jpg";
GambleAssetConfig.BLACK_SPADE_HISTORY = "cards/CardHistory/CardHistoryBlackSpades.jpg";
GambleAssetConfig.FIFTY_FIFTY_CHOICE = "choiceScreen/CardsButton.png";
GambleAssetConfig.FIFTY_FIFTY_CHOICE_TOGGLE = "choiceScreen/CardsButtonHighlight.png";
GambleAssetConfig.WHEEL_CHOICE = "choiceScreen/WheelButton.png";
GambleAssetConfig.WHEEL_CHOICE_TOGGLE = "choiceScreen/WheelButtonHighlight.png";
GambleAssetConfig.POINTER_0 = "wheelOfBonus/Pointer/pointer_0.png";
GambleAssetConfig.POINTER_1 = "wheelOfBonus/Pointer/pointer_1.png";
GambleAssetConfig.POINTER_2 = "wheelOfBonus/Pointer/pointer_2.png";
GambleAssetConfig.POINTER_3 = "wheelOfBonus/Pointer/pointer_3.png";
GambleAssetConfig.POINTER_4 = "wheelOfBonus/Pointer/pointer_4.png";
GambleAssetConfig.POINTER_5 = "wheelOfBonus/Pointer/pointer_5.png";
GambleAssetConfig.POINTER_6 = "wheelOfBonus/Pointer/pointer_6.png";
GambleAssetConfig.POINTER_7 = "wheelOfBonus/Pointer/pointer_7.png";
GambleAssetConfig.POINTER_8 = "wheelOfBonus/Pointer/pointer_8.png";
GambleAssetConfig.POINTER_9 = "wheelOfBonus/Pointer/pointer_9.png";
GambleAssetConfig.POINTER_10 = "wheelOfBonus/Pointer/pointer_10.png";
GambleAssetConfig.POINTER_11 = "wheelOfBonus/Pointer/pointer_11.png";
GambleAssetConfig.POINTER_12 = "wheelOfBonus/Pointer/pointer_12.png";
GambleAssetConfig.POINTER_13 = "wheelOfBonus/Pointer/pointer_13.png";
GambleAssetConfig.POINTER_14 = "wheelOfBonus/Pointer/pointer_14.png";
GambleAssetConfig.POINTER_15 = "wheelOfBonus/Pointer/pointer_15.png";
GambleAssetConfig.POINTER_16 = "wheelOfBonus/Pointer/pointer_16.png";
GambleAssetConfig.POINTER_17 = "wheelOfBonus/Pointer/pointer_17.png";
GambleAssetConfig.FEATURE_IMAGE = "wheelOfBonus/FeatureImage.png";
GambleAssetConfig.OUTER_RING = "wheelOfBonus/OuterRing.png";
GambleAssetConfig.OUTER_RING_GLOW = "wheelOfBonus/OuterRingGlow.jpg";
GambleAssetConfig.WHEEL = "wheelOfBonus/Wheel.png";
GambleAssetConfig.WHEEL_GLOW = "wheelOfBonus/WheelGlow.png";
GambleAssetConfig.WIN_WHEEL_GLOW_0 = "wheelOfBonus/Win/Win_Wheel/Win_Wheel_Glow_0.jpg";
GambleAssetConfig.WIN_WHEEL_GLOW_1 = "wheelOfBonus/Win/Win_Wheel/Win_Wheel_Glow_1.jpg";
GambleAssetConfig.WIN_WHEEL_GLOW_2 = "wheelOfBonus/Win/Win_Wheel/Win_Wheel_Glow_2.jpg";
GambleAssetConfig.WIN_WHEEL_GLOW_3 = "wheelOfBonus/Win/Win_Wheel/Win_Wheel_Glow_3.jpg";
GambleAssetConfig.WIN_WHEEL_GLOW_4 = "wheelOfBonus/Win/Win_Wheel/Win_Wheel_Glow_4.jpg";
GambleAssetConfig.WIN_WHEEL_GLOW_5 = "wheelOfBonus/Win/Win_Wheel/Win_Wheel_Glow_5.jpg";
GambleAssetConfig.WIN_WHEEL_GLOW_6 = "wheelOfBonus/Win/Win_Wheel/Win_Wheel_Glow_6.jpg";
GambleAssetConfig.WIN_OUTER_RING_GLOW_0 = "wheelOfBonus/Win/Win_OuterRing/Win_OuterRing_Glow_0.jpg";
GambleAssetConfig.WIN_OUTER_RING_GLOW_1 = "wheelOfBonus/Win/Win_OuterRing/Win_OuterRing_Glow_1.jpg";
GambleAssetConfig.WIN_OUTER_RING_GLOW_2 = "wheelOfBonus/Win/Win_OuterRing/Win_OuterRing_Glow_2.jpg";
GambleAssetConfig.WIN_OUTER_RING_GLOW_3 = "wheelOfBonus/Win/Win_OuterRing/Win_OuterRing_Glow_3.jpg";
GambleAssetConfig.WIN_OUTER_RING_GLOW_4 = "wheelOfBonus/Win/Win_OuterRing/Win_OuterRing_Glow_4.jpg";
GambleAssetConfig.WIN_OUTER_RING_GLOW_5 = "wheelOfBonus/Win/Win_OuterRing/Win_OuterRing_Glow_5.jpg";
GambleAssetConfig.WIN_OUTER_RING_GLOW_6 = "wheelOfBonus/Win/Win_OuterRing/Win_OuterRing_Glow_6.jpg";
GambleAssetConfig.WIN_OUTER_RING_GLOW_7 = "wheelOfBonus/Win/Win_OuterRing/Win_OuterRing_Glow_7.jpg";
GambleAssetConfig._useDefaultAssets = false;
//# sourceMappingURL=GambleAssetConfig.js.map